import { render, staticRenderFns } from "./BillingOverdueTopAlert.vue?vue&type=template&id=2e0a64b6&scoped=true"
import script from "./BillingOverdueTopAlert.vue?vue&type=script&lang=js"
export * from "./BillingOverdueTopAlert.vue?vue&type=script&lang=js"
import style0 from "./BillingOverdueTopAlert.vue?vue&type=style&index=0&id=2e0a64b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a64b6",
  null
  
)

export default component.exports